/* eslint-disable */
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { FullWidthWrapper } from './style'
import RadioButton from 'components/RadioButton'
import Input from 'components/Input'
import Textarea from 'components/Textarea'
import Select from 'components/Select/selectAbout'
import InfoIcon from 'assets/icons/info-icon'
import InfoSmallIcon from 'assets/icons/info-small-icon'
import Tooltip from 'components/Tooltip'

import { PageTitle, PageSubtitle, PageSubtitleWrapper, TooltipHintWrapper } from 'flow/SiteProposal/pages/About/style'

const StateEvaluationSection = ({
  evaluationType,
  setEvaluationType,
  isChangeGenuine,
  setIsChangeGenuine,
  benchmarkValue,
  setBenchmarkValue,
  speciesState,
  setSpeciesState,
  ecosystemState,
  setEcosystemState,
  inferringMethod,
  setInferringMethod,
  justification,
  setJustification,
  radioOptions,
  stateOptions,
  inferringOptions,
  StateEvaluationtyp,
  scheduleSave,
  triggerItem,
  isSiteStateValid = true,
  isEditable
}) => {
  const itemType = triggerItem?.raw?.category

  return (
    <>
      <PageTitle style={{ marginTop: '35px' }}>
        <FormattedMessage id="stateTitle" />
      </PageTitle>

      <PageSubtitleWrapper>
        <PageSubtitle>
          <FormattedMessage id="bioSubTitle" />
        </PageSubtitle>

        <Tooltip
          style={{ zIndex: 1000 }}
          placement="bottom"
          trigger={['hover']}
          align={{ offset: [0, 16] }}
          overlay={{
            label: 'stateTitle',
            infoTooltip: 'stateEvaluationHint'
          }}
          type="big"
        >
          <TooltipHintWrapper>
            <InfoIcon />
          </TooltipHintWrapper>
        </Tooltip>
      </PageSubtitleWrapper>

      <FullWidthWrapper>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: '1px' }}>
          <FormattedMessage id="natureOfTheStateEvaluation" />
          <Tooltip
            style={{ zIndex: 1000 }}
            placement="bottom"
            trigger={['hover']}
            align={{ offset: [0, 16] }}
            overlay={{
              label: 'natureOfTheStateEvaluation',
              infoTooltip: 'toolTipbenchmarkfield'
            }}
            type="big"

>
            <TooltipHintWrapper>
              <InfoSmallIcon />
            </TooltipHintWrapper>
          </Tooltip>
        </div>
        <div style={{ marginTop: '12px' }}>
          {StateEvaluationtyp?.map((option) => (
            <RadioButton
              key={option.value}
              name="evaluationType"
              value={option.value}
              label={option.label}
              checked={evaluationType === option.value}
              disabled={!isEditable}
              Tooltip="toolTip1"
              
              onChange={(value) => {
                setEvaluationType(value)
                scheduleSave('state_evaluation_type_id', value)
              }}
            />
          ))}
        </div>
        {!isSiteStateValid && !evaluationType && (
          <div style={{ color: 'rgba(225, 25, 0, 1)', fontSize: '14px', marginTop: '0px', marginBottom: '40px' }}>
            <FormattedMessage id="pleaseCompleteThisField" />
          </div>
        )}
      </FullWidthWrapper>

      {evaluationType === 1 && (
        <>
          <FullWidthWrapper style={{ maxWidth: '60%' }}>
            <Input
              type="number"
              label="updateEstimate"
              placeholder="Value"
              value={benchmarkValue}
              disabled={!isEditable}
              marginBottomInput="50px"
              infoTooltip="tooltip3"
              onChange={(e) => {
                const value = e.target.value
                setBenchmarkValue(value)
                scheduleSave('update_estimate', value)
              }}
              field="updateEstimate"
              error={
                isSiteStateValid || benchmarkValue
                  ? { field: '', error: '' }
                  : {
                      field: 'updateEstimate',
                      error: 'pleaseCompleteThisField'
                    }
              }
            />
          </FullWidthWrapper>

          {itemType === 'ecosystem' && (
            <>
              <FullWidthWrapper>
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '1px' }}>
                  <FormattedMessage id="stateCategoryEcosystem" />
                  <Tooltip
                    style={{ zIndex: 1000 }}
                    placement="bottom"
                    trigger={['hover']}
                    align={{ offset: [0, 16] }}
                    overlay={{
                      label: 'stateCategoryEcosystem',
                      infoTooltip: 'toolTipbenchmarkfield6'
                    }}
                    type="big"
                  >
                    <TooltipHintWrapper>
                      <InfoSmallIcon />
                    </TooltipHintWrapper>
                  </Tooltip>
                </div>

                <div style={{ marginTop: '12px' }}>
                  {stateOptions.map((option) => (
                    <RadioButton
                      key={option.value}
                      name="ecosystemState"
                      value={option.value}
                      disabled={!isEditable}
                      checked={ecosystemState === option.value}
                      onChange={(value) => {
                        setEcosystemState(value)
                        scheduleSave('state_category_condition_id', value)
                      }}
                      label={option.label}
                      dataTest={`ecosystemState-${option.value}`}
                    />
                  ))}
                </div>
                {!isSiteStateValid && !ecosystemState && (
                  <div
                    style={{ color: 'rgba(225, 25, 0, 1)', fontSize: '14px', marginTop: '0px', marginBottom: '40px' }}
                  >
                    <FormattedMessage id="pleaseCompleteThisField" />
                  </div>
                )}
              </FullWidthWrapper>

              <FullWidthWrapper>
                <Select
                  label="categoryInferring"
                  placeholder="Select method"
                  options={inferringOptions}
                  value={inferringMethod}
                  disabled={!isEditable}
                  infoTooltip="toolTip7"
                  onChange={(selected) => {
                    setInferringMethod(selected)
                    scheduleSave('state_category_source_id', selected?.value)
                  }}
                  field="inferringMethod"
                  error={
                    isSiteStateValid || inferringMethod
                      ? { field: '', error: '' }
                      : {
                          field: 'inferringMethod',
                          error: 'pleaseCompleteThisField'
                        }
                  }
                  blueBg={true}
                />
              </FullWidthWrapper>

              <FullWidthWrapper>
                <Textarea
                  label="furtherDetailsJustify"
                  value={justification}
                  onChange={(e) => {
                    const value = e.target.value
                    setJustification(value)
                    scheduleSave('state_category_justification', value)
                  }}
                  placeholder="enterDetails"
                  disabled={!isEditable}
                  infoTooltip="toolTip8"
                  height="128px"
                  maxLength={255}
                  showCharCount={true}
                  field="justification"
                  error={
                    isSiteStateValid || justification
                      ? { field: '', error: '' }
                      : {
                          field: 'justification',
                          error: 'pleaseCompleteThisField'
                        }
                  }
                />
              </FullWidthWrapper>
            </>
          )}

          <FullWidthWrapper>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '1px' }}>
              <FormattedMessage id="changeGenuine" />
              <Tooltip
                style={{ zIndex: 1000 }}
                placement="bottom"
                trigger={['hover']}
                align={{ offset: [0, 16] }}
                overlay={{
                  label: 'changeGenuine',
                  infoTooltip: 'toolTip2'
                }}
                type="big"
              >
                <TooltipHintWrapper>
                  <InfoSmallIcon />
                </TooltipHintWrapper>
              </Tooltip>
            </div>
            <div style={{ marginTop: '12px', marginBottom: '90px' }}>
              {radioOptions.map((option) => (
                <RadioButton
                  key={option.value}
                  name="isChangeGenuine"
                  value={option.value}
                  disabled={!isEditable}
                  Tooltip="toolTip1"
                  checked={isChangeGenuine === option.value}
                  onChange={(newValue) => {
                    const nextValue = isChangeGenuine === newValue ? null : newValue
                    setIsChangeGenuine(nextValue)
                    scheduleSave('genuine_change', nextValue)
                  }}
                  label={option.label}
                  dataTest={`radio-${option.value}`}
                />
              ))}
            </div>
            {!isSiteStateValid && !(isChangeGenuine === true || isChangeGenuine === false) && (
              <div style={{ color: 'rgba(225, 25, 0, 1)', fontSize: '14px', marginTop: '-80px', marginBottom: '40px' }}>
                <FormattedMessage id="pleaseCompleteThisField" />
              </div>
            )}
          </FullWidthWrapper>
        </>
      )}

      {evaluationType === 2 && (
        <>
          {itemType === 'species' && (
            <>
              <FullWidthWrapper >
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '1px' }}>
                  <FormattedMessage id="stateCategoryBestDescribes" />
                  <Tooltip
                    style={{ zIndex: 1000 }}
                    placement="bottom"
                    trigger={['hover']}

                    overlay={{
                      label: 'stateCategoryBestDescribes',
                      infoTooltip: 'toolTipbenchmarkfield5'
                    }}
                    type="big"
                  >
                    <TooltipHintWrapper>
                      <InfoSmallIcon />
                    </TooltipHintWrapper>
                  </Tooltip>
                </div>

                <div style={{ marginTop: '12px' }}>
                  {stateOptions.map((option) => (
                    <RadioButton
                      key={option.value}
                      name="speciesState"
                      value={option.value}
                      disabled={!isEditable}
                      infoTooltip="tooltip3"
                      checked={speciesState === option.value}
                      onChange={(value) => {
                        setSpeciesState(value)
                        scheduleSave('state_category_extent_id', value)
                      }}
                      label={option.label}
                      dataTest={`speciesState-${option.value}`}
                    />
                  ))}
                </div>
                {!isSiteStateValid && !speciesState && (
                  <div
                    style={{ color: 'rgba(225, 25, 0, 1)', fontSize: '14px', marginTop: '0px', marginBottom: '40px' }}
                  >
                    <FormattedMessage id="pleaseCompleteThisField" />
                  </div>
                )}
              </FullWidthWrapper>
            </>
          )}

          {itemType === 'ecosystem' && (
            <>
              <FullWidthWrapper>
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '1px' }}>
                  <FormattedMessage id="stateCategoryBestDescribes" />
                  <Tooltip
                    style={{ zIndex: 1000 }}
                    placement="bottom"
                    trigger={['hover']}

                    overlay={{
                      label: 'stateCategoryBestDescribes',
                      infoTooltip: 'toolTipbenchmarkfield5'
                    }}
                    type="big"
                  >
                    <TooltipHintWrapper>
                      <InfoSmallIcon />
                    </TooltipHintWrapper>
                  </Tooltip>
                </div>

                <div style={{ marginTop: '12px' }}>
                  {stateOptions.map((option) => (
                    <RadioButton
                      key={option.value}
                      name="speciesState"
                      value={option.value}
                      disabled={!isEditable}
                      checked={speciesState === option.value}
                      onChange={(value) => {
                        setSpeciesState(value)
                        scheduleSave('state_category_extent_id', value)
                      }}
                      label={option.label}
                      dataTest={`speciesState-${option.value}`}
                    />
                  ))}
                </div>
                {!isSiteStateValid && !speciesState && (
                  <div
                    style={{ color: 'rgba(225, 25, 0, 1)', fontSize: '14px', marginTop: '0px', marginBottom: '40px' }}
                  >
                    <FormattedMessage id="pleaseCompleteThisField" />
                  </div>
                )}
              </FullWidthWrapper>
              <FullWidthWrapper>
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '1px' }}>
                  <FormattedMessage id="stateCategoryEcosystem" />
                  <Tooltip
                    style={{ zIndex: 1000 }}
                    placement="bottom"
                    trigger={['hover']}
                    align={{ offset: [0, 16] }}
                    overlay={{
                      label: 'stateCategoryEcosystem',
                      infoTooltip: 'toolTipbenchmarkfield6'
                    }}
                    type="big"
                  >
                    <TooltipHintWrapper>
                      <InfoSmallIcon />
                    </TooltipHintWrapper>
                  </Tooltip>
                </div>

                <div style={{ marginTop: '12px' }}>
                  {stateOptions.map((option) => (
                    <RadioButton
                      key={option.value}
                      name="ecosystemState"
                      value={option.value}
                      disabled={!isEditable}
                      checked={ecosystemState === option.value}
                      onChange={(value) => {
                        setEcosystemState(value)
                        scheduleSave('state_category_condition_id', value)
                      }}
                      label={option.label}
                      dataTest={`ecosystemState-${option.value}`}
                    />
                  ))}
                </div>
                {!isSiteStateValid && !ecosystemState && (
                  <div
                    style={{ color: 'rgba(225, 25, 0, 1)', fontSize: '14px', marginTop: '0px', marginBottom: '40px' }}
                  >
                    <FormattedMessage id="pleaseCompleteThisField" />
                  </div>
                )}
              </FullWidthWrapper>
            </>
          )}

          <FullWidthWrapper>
            <Select
              label="categoryInferring"
              placeholder="Select method"
              options={inferringOptions}
              value={inferringMethod}
              disabled={!isEditable}
              infoTooltip="toolTip7"
              onChange={(selected) => {
                setInferringMethod(selected)
                scheduleSave('state_category_source_id', selected?.value)
              }}
              field="inferringMethod"
              error={
                isSiteStateValid || inferringMethod
                  ? { field: '', error: '' }
                  : {
                      field: 'inferringMethod',
                      error: 'pleaseCompleteThisField'
                    }
              }
              blueBg={true}
            />
          </FullWidthWrapper>

          <FullWidthWrapper>
            <Textarea
              label="furtherDetailsJustify"
              value={justification}
              onChange={(e) => {
                const value = e.target.value
                setJustification(value)
                scheduleSave('state_category_justification', value)
              }}
              placeholder="enterDetails"
              disabled={!isEditable}
              infoTooltip="toolTip8"
              height="128px"
              showCharCount={true}
              maxLength={255}
              field="justification"
              error={
                isSiteStateValid || justification
                  ? { field: '', error: '' }
                  : {
                      field: 'justification',
                      error: 'pleaseCompleteThisField'
                    }
              }
            />
          </FullWidthWrapper>

          <FullWidthWrapper>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '1px' }}>
              <FormattedMessage id="changeGenuine" />
              <Tooltip
                style={{ zIndex: 1000 }}
                placement="bottom"
                trigger={['hover']}
                align={{ offset: [0, 16] }}
                overlay={{
                  label: 'changeGenuine',
                  infoTooltip: 'toolTip2'
                }}
                type="big"
              >
                <TooltipHintWrapper>
                  <InfoSmallIcon />
                </TooltipHintWrapper>
              </Tooltip>
            </div>
            <div style={{ marginTop: '12px', marginBottom: '90px' }}>
              {radioOptions.map((option) => (
                <RadioButton
                  key={option.value}
                  name="isChangeGenuine"
                  value={option.value}
                  disabled={!isEditable}
                  checked={isChangeGenuine === option.value}
                  onChange={(value) => {
                    setIsChangeGenuine(value)
                    scheduleSave('genuine_change', value)
                  }}
                  label={option.label}
                  infoTooltip="Is the change genuine info"
                  dataTest={`radio-${option.value}`}
                />
              ))}
            </div>
            {!isSiteStateValid && !(isChangeGenuine === true || isChangeGenuine === false) && (
              <div style={{ color: 'rgba(225, 25, 0, 1)', fontSize: '14px', marginTop: '-80px', marginBottom: '40px' }}>
                <FormattedMessage id="pleaseCompleteThisField" />
              </div>
            )}
          </FullWidthWrapper>
        </>
      )}
    </>
  )
}

export default StateEvaluationSection
